'use client'

import { useTranslations } from 'next-intl'
import { useIsLoggedInQuery } from 'auth/hooks'
import {
  useHasAllAccessQuery,
  useUserIsEligibleForAllAccessFreeTrialQuery,
} from '@repo/cf-user/hooks/use-user-data'
import { Button } from '@repo/design-system-cf/components/button'
import { StartFreeTrialButton } from 'payments/start-free-trial-button'
import { DownloadDoneIcon, InPaintingIcon, LockOpenIcon } from '../../../assets/icons'
import { PAYMENT_ENTRY_POINTS } from 'payments/payments-dialog/analytics'

export function JoinClub() {
  const t = useTranslations('pages.clubhouse')
  const { data: isLoggedIn } = useIsLoggedInQuery()
  const { data: isEligibleForAllAccessFreeTrial } = useUserIsEligibleForAllAccessFreeTrialQuery()
  const { data: userHasAllAccess } = useHasAllAccessQuery()

  return (
    <section className="bg-cf-white rounded-[12px] w-full overflow-hidden border border-[#DADCE2]">
      <div className="flex w-full flex-col items-start justify-start px-4 pb-4 ">
        <p className="text-16 mt-4 py-1 pl-2.5 font-bold">{t('sidebar.join')}</p>
        <p className="text-12 mt-1  bg-[#FEE9CC] px-2 py-1 font-normal">{t('sidebar.access')}</p>
        <div className="mt-3 flex flex-row items-start justify-start">
          <LockOpenIcon className=" mt-2 size-6" />
          <p className="text-14 px-2 py-1 font-normal">{t('sidebar.unlock')}</p>
        </div>
        <div className="mt-3 flex flex-row items-start justify-start">
          <DownloadDoneIcon className="mt-2 size-7" />
          <p className="text-14 px-2 py-1 font-normal">{t('sidebar.unlimited')}</p>
        </div>{' '}
        <div className="mt-3 flex flex-row items-start justify-start">
          <InPaintingIcon className="mt-2 size-3" />
          <p className="text-14 px-2 py-1 font-normal">{t('sidebar.studio')}</p>
        </div>
        {!isLoggedIn || (isLoggedIn && !userHasAllAccess && isEligibleForAllAccessFreeTrial) ? (
          <Button className="min-h-auto mb-1 mt-4 whitespace-normal py-2.5" asChild>
            <StartFreeTrialButton
              entryPoint={PAYMENT_ENTRY_POINTS.SOCIAL_CLUBHOUSE_JOIN}
              label={t('sidebar.try')}
              className="px-4"
            />
          </Button>
        ) : null}
        <p className="mb-3 mt-2 text-[11px] leading-[13px]">
          {t('sidebar.risk') + ' - ' + t('sidebar.cancel')}
        </p>
      </div>
    </section>
  )
}
